<template lang="pug">
    v-dialog(v-model="showSettings" width="450px")
        div(class="popup-title")
            span() {{ $t('User_settings') }}
            span(class="sub-title") {{this.user.email}}

        div()

            //- Choose language

            div(class="settings-row")
                label() {{ $t('Language') }}
                div()
                    v-btn-toggle(mandatory
                                 id="language"
                                 :value="language"
                                 color="white"
                                 style="")
                        //- v-btn(@click="" x-small tile depressed value="da" disabled) Danish
                        //- v-btn(@click="" x-small tile depressed value="no" disabled) Norwegian
                        v-btn(v-if="toggledEN" @click="change_english('en')" color="#144B4D" small tile depressed value="en" style="") {{ $t('English') }}
                        v-btn(v-if="!toggledEN" @click="change_english('en')" color="white" small tile depressed value="en" style="") {{ $t('English') }}

                        v-btn(v-if="toggledSV" @click="change_swedish('sv')" color="#144B4D" small tile depressed value="sv" style="") {{ $t('Swedish') }}
                        v-btn(v-if="!toggledSV" @click="change_swedish('sv')" color="white" small tile depressed value="sv" style="") {{ $t('Swedish') }}

            //- Reset Password
            div(class="settings-row")
                label() {{ $t('Current_Password') }}
                div()
                    v-text-field(
                        hide-details="true"
                        v-model="password"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPass ? 'text' : 'password'"
                        :rules="[rules.required, rules.min]"
                        name="password"
                        hint="At least 8 characters"
                        @click:append="showPass = !showPass"
                        outlined dense flat)

            div(class="settings-row")
                label() {{ $t('New_Password') }}
                div()
                    v-text-field(
                        hide-details="true"
                        v-model="newPassword"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPass ? 'text' : 'password'"
                        :rules="[rules.required, rules.min]"
                        name="password"
                        hint="At least 8 characters"
                        @click:append="showPass = !showPass"
                        outlined dense flat)

            div(class="settings-row")
                label() {{ $t('Confirm_New_Password') }}
                div()
                    v-text-field(
                        hide-details="true"
                        v-model="confirmedNewPassword"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPass ? 'text' : 'password'"
                        :rules="[rules.required, rules.min]"
                        name="password"
                        hint="At least 8 characters"
                        @click:append="showPass = !showPass"
                        outlined dense flat)

            div(class="settings-row text-right")
                button(class="btn-primary" @click.prevent='resetPassword') {{ $t('Apply') }}

            //- Notifications
            div(class="settings-row")
                label() {{this.$t('Weekly_Reports')}}
                div()
                    v-switch(style=""
                             inset hide-details
                             color="ta_brand_bg_clr"
                             @change="updateNotifications()"
                             v-model="userNotifications.weeklyReports")

            div(class="settings-row")
                label() {{this.$t('Newsletters')}}
                div()
                    v-switch(style=""
                             inset hide-details
                             color="ta_brand_bg_clr"
                             @change="updateNotifications()"
                             v-model="userNotifications.newsletters")

            //- Delete account
            div(class="settings-row delete-account")
                div()
                    v-btn(v-if="!deleteDialog"
                          style=""
                          color=""
                          class="mr-4 delete-btn"
                          @click="showDialogDelete") {{ $t('Delete_Registration') }}
                    div(v-if="deleteDialog"
                        style="background-color:#f4f4f4;position:absolute;width:100%;height:100%;left:0;top:0;text-align:center;padding-top:12px")
                        span(style="margin-bottom: 4px;display:block") {{ $t('confirm_with_password') }}
                        div(style="width:215px;margin:0 auto;")
                            v-text-field(
                                hide-details="true"
                                v-model="passwordToDeleteAcc"
                                name="password"
                                hint="At least 8 characters"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPass ? 'text' : 'password'"
                                :rules="[rules.required, rules.min]"
                                @click:append="showPass = !showPass"
                                outlined dense flat
                                )
                            div(style="display:flex; justify-content:center; margin-top: 10px;")
                                v-btn(class="btn-secondary mr-3" small @click.prevent="cancelDelete") {{ $t('Cancel') }}
                                v-btn(class="btn-secondary" style="border-color:red; color:red" small @click.prevent="deleteRegistration" ) {{ $t('Confirm_Delete') }}
                div()
                    h6() {{ $t('Privacy_and_Delete_Account') }}
                    p(style="font-size: 12px; line-height:1.1") {{ $t('Remove_all_data_for_this_account_and_forget_me_forever') }}





            //- Popup to inform account deleted
            v-dialog(v-model="accountDeletedPopup" max-width="400px")
                v-card(class="confirmDeletePopup")
                    div(class="deletePopupText")
                        span Your data will be deleted tonight

            //- Save and Close Button
            div(class="settings-row text-right")
                button(class="btn-secondary mr-4") {{ $t('Cancel') }}
                button(class="btn-primary" @click.prevent='saveAndClose') {{ $t('Apply') }}

            //- tr
            //-     td(class="left px-4") {{ $t('Theme') }}
            //-     td(class="left")
            //-         v-btn-toggle(mandatory id="theme" :value="isDark" color="primary")
            //-             v-btn(@click="change_theme('false')" x-small tile depressed value="false") Bright
            //-             v-btn(@click="change_theme('true')" x-small tile depressed value="true") Dark
</template>

<script>
import apiService from "@/Services/ApiService";
import ApiService from "../../Services/ApiService";
import i18n from "@/plugins/i18n";
import Cookies from 'js-cookie';
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: "UserSettings",
    components: {apiService},
    props: {
        value: Boolean
    },
    data() {
        return {
            showSettings: false,
            toggledEN: false,
            toggledSV: false,
            accountDeletedPopup: false,
            passwordToDeleteAcc: "",
            deleteDialog: false,
            userNotifications: {
                weeklyReports: true,
                newsletters: true
            },
            user: {email: "pending"},
            showPass: false,
            password: "",
            newPassword: "",
            confirmedNewPassword: "",
            rules: {
                required: value => !!value || "Required.",
                min: v => v.length >= 8 || "Min 8 characters",
            },
            language: "sv",
            darkMode: false
        };
    },
    methods: {
        ...mapMutations([
            'setShowUserSettings'
        ]),
        async deleteRegistration() {
            const email = JSON.parse(localStorage.user).email;
            const password = this.passwordToDeleteAcc;
            const verifyPass = await this.verifyUserPassword(email, password);

            if(verifyPass){
                this.accountDeletedPopup = true;
                setTimeout(async function() {
                    await ApiService.deleteUser(this.user.user_id);
                    localStorage.removeItem('user');
                    Cookies.remove('user');
                    window.location.href = "/";
                }, 1500);
            };
        },
        cancelDelete() {
            this.deleteDialog = false;
            this.passwordToDeleteAcc = "";
        },
        showDialogDelete() {
            this.deleteDialog = true;
        },
        async updateNotifications() {
            const requestBody = {
                user_id : this.user.user_id,
                weekly: this.userNotifications.weeklyReports,
                newsletter: this.userNotifications.newsletters
            };
            await ApiService.userNotifications(requestBody);
            const user = await ApiService.findUser(JSON.parse(localStorage.user).user_id);
            this.user = user;
        },
        async change_swedish(local) {
            i18n.locale = local;
            this.language = local;

            let temp = {};
            temp.is_dark = this.darkMode;
            temp.language = local;
            temp.settings = this.$store.getters.getUserSettings;

            const userSettings = {
                id: JSON.parse(localStorage.user).user_id,
                settings: temp
            }
            await ApiService.addUserSettings(userSettings)
            this.updateLocalstorageUserData(temp);
            this.toggledEN = false;
            this.toggledSV = true;
        },
        async change_english(local) {
            i18n.locale = local;
            this.language = local;

            let temp = {};
            temp.is_dark = this.darkMode;
            temp.language = local;
            temp.settings = this.$store.getters.getUserSettings;

            const userSettings = {
                id: JSON.parse(localStorage.user).user_id,
                settings: temp
            }
            await ApiService.addUserSettings(userSettings);
            this.updateLocalstorageUserData(temp);
            this.toggledEN = true;
            this.toggledSV = false;
        },
        getTodaysDate() {
            return new Date().toISOString().slice(0, 10);
        },
        saveAndClose() {
            this.user.settings = {
                language: this.language,
                // currency: this.currency,
                // dateFormat: "YYYY-MM-DD",
                // theme: this.theme
            };
            this.passwordToDeleteAcc = "";
            this.password = "";
            this.confirmedNewPassword = "";
            this.newPassword = "";
            this.deleteDialog = false;

            this.showDialog = false;
            // this.screen = {
            //     tabs: ["dashboard", "ERIC_B", "watchlist", "portfolio", "ESENSE"]
            // };
            // this.account = {}; //?

            // ApiService.updateUser(this.user).then(user => {
            //   localStorage.user = user;
            // });
        },
        async verifyUserPassword(email, password) {
            const userRequestData = {
                email: email,
                password: password
            }
            const passwordBoolean = (await ApiService.verifyUserPassword(userRequestData)).data.passwordVerify;
            if(passwordBoolean){
                return true;
            } else {
                this.$store.commit('setMessage', { text: 'Incorrect password', type: 'error' });
                return false;
            }
        },

        async resetPassword() {
            const email = JSON.parse(localStorage.user).email;
            const password = this.password;

            const userRequestData = {
                id: JSON.parse(localStorage.user).user_id,
                password: this.newPassword
            }
            const verifyPass = await this.verifyUserPassword(email, password);

            if(verifyPass) {
                if (this.password.length >= 8 && this.confirmedNewPassword.length >= 8 && this.newPassword.length >= 8 && this.confirmedNewPassword === this.newPassword) {
                    await ApiService.resetPassword(userRequestData);
                    this.$store.commit('setMessage', { text: 'Password changed successfully', type: 'success' });
                } else {
                    this.$store.commit('setMessage', { text: 'Incorrect password', type: 'error' });
                }
            } else {
                console.log("password is not correct");
            }
            
        },
        updateLocalstorageUserData(settings) {
            let temp = JSON.parse(localStorage.user);
            temp.settings = JSON.stringify(settings);
            localStorage.user = JSON.stringify(temp);
        }
    },
    computed: {
        ...mapGetters([
            'getShowUserSettings'
        ]),
        isDark: {
            get() {
                return this.$vuetify.theme.isDark;
            },
            set() {
                this.$vuetify.theme.isDark = !this.$vuetify.theme.isDark;
            }
        }
    },

    watch: {
        getShowUserSettings() {
            if(this.getShowUserSettings === true) {
                this.showSettings = true;

                this.setShowUserSettings(false);
            }
        }
    },

    mounted() {
        if (localStorage.user) {
            var temp_user_data = JSON.parse(localStorage.user);
            if (JSON.parse(localStorage.user).subscription_id != null) {
                temp_user_data.type = "premium";
            }
            this.user = temp_user_data;
        }
        let is_obj = typeof JSON.parse(localStorage.user).settings === "object" ? JSON.parse(localStorage.user).settings : JSON.parse(JSON.parse(localStorage.user).settings);
        if (is_obj.language) {
            this.language = is_obj.language;
        } else {
            this.language = "sv";
        }

        if(this.language === "sv") {
            this.toggledEN = false;
            this.toggledSV = true;
        } else {
            this.toggledEN = true;
            this.toggledSV = false;
        }

        if (is_obj.is_dark) {
            this.darkMode = is_obj.is_dark;
        } else {
            this.darkMode = false;
        }
    },

    created: async function () {
        const user = await ApiService.findUser(JSON.parse(localStorage.user).user_id);
        this.userNotifications.weeklyReports = user.email_weekly;
        this.userNotifications.newsletters = user.email_newsletter;
        if (user.subscription_id != null) {
            user.type = "premium";
        }
        this.user = user;
    }
};
</script>

<style scoped>

>>>.v-dialog {
    padding: 22px;
    background: white;
    border: 1px solid rgba(0, 0, 0, .1);
    box-shadow: 0 0 12px rgba(0,0,0,.3);
    border-radius:8px;
}

.sub-title {
    display: block;
    font-size: 16px;
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
    margin-bottom: 22px;
}

.settings-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 12px;
}

.settings-row label {
    width: 40%;
    text-transform: capitalize;
}

.settings-row label + div {
    flex-grow: 1;
}

.settings-row.text-right {
    justify-content: flex-end;
}

>>>.settings-row fieldset {
    border: 0;
}
>>>.settings-row .v-input:not(.v-input--switch) .v-input__slot {
    border: 1px solid rgba(20,75,77,1);
    min-height: 32px;
    padding-right: 4px;
}
>>>.settings-row .v-input.v-input--switch {
    margin-top: 0;
    padding-top: 0;
    font-size: 12px;
}
>>>.settings-row .v-input.v-input--switch .v-input__slot {
    width: 42px;
}
>>>.settings-row .v-btn-toggle {
    border: 1px solid #144B4D;
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
}
>>>.settings-row .v-btn-toggle .v-btn {
    font-size: 11px;
    font-weight: 400;
    width: 50%;
    text-transform: capitalize;
    border: 0;
}
>>>.v-input__append-inner {
    margin-top: 4px !important;
}
>>>.v-input__append-inner .v-icon.v-icon {
    font-size: 18px;
}

.settings-row.delete-account {
    padding: 15px;
    position: relative;
    height: 120px;
    border-radius: 5px;
    border: 1px solid #f4f4f4;
}

.settings-row.delete-account .v-input {
    background-color: white
}

.delete-btn {
    box-shadow: none;
    border: 1px solid red;
    border-radius: 4px;
    color: red;
}

.settings-row.delete-account > div:first-child {
    width: 50%;
}

</style>
